module.exports = __webpack_public_path__ + "static/media/3.33a06f27.jpg";